export default {
    Kiosk_Customer:'Kiosk',
    Portal_Customer:'Portal',
    Enrolled_Customer:'Enrolled',
    PMS_Customer: 'PMS',
    KAKTUS_PATIENT: 'KAKTUS_PATIENT'
  };


// WEBPACK FOOTER //
// ./src/components/common/customer_type.js